/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_No_Sessions_FoundInputs */

const en_audit_no_sessions_found = /** @type {(inputs: Audit_No_Sessions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit sessions found.`)
};

const es_audit_no_sessions_found = /** @type {(inputs: Audit_No_Sessions_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron sesiones de auditoria.`)
};

/**
* | output |
* | --- |
* | "No audit sessions found." |
*
* @param {Audit_No_Sessions_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_no_sessions_found = /** @type {((inputs?: Audit_No_Sessions_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_No_Sessions_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_no_sessions_found(inputs)
	return es_audit_no_sessions_found(inputs)
});